import { useContext } from 'react';
import { StoreContext } from '../../store';
import { Show } from '../../utility/Show';
import './index.css';
import {
  getLSData,
} from '../../services.js';

import { createCheckoutSession } from '../../utils/stripe';

const subscriptionPlans = [
  {
    tier: 'free',
    name: 'Free',
    price: 0,
    per_month: false,
    features: [
      "10 searches per month",
      "Summary Dashboard",
      "Lifestyle essentials score",
      "Sidewalk character score",
      "5-10-20 min walking distance",
      "Detail maps",
      "Compare neighborhoods",
      "Multiple search",
      "Filters",
      "Ratings",
      "Health metrics",
      "CO2 saved emissions",
    ],
  },
  {
    tier: 'premium',
    name: 'Premium',
    price: 29.99,
    per_month: true,
    features: [
      "Everything in free",
      "Unlimited search",
      // "Mobile version",
      "Technical support",
      "White label format",
      // "10 cities",
      // "Nieghborhood match",
      // "Analysis"
    ],
  },
  {
    tier: 'enterprise',
    name: 'Enterprise',
    price: 59.99,
    per_month: true,
    features: [
      "Everything in premium",
      "Bespoke customization",
      "Neighborhood report",
      "Analytics report",
      "Neighborhood Preference Profile",
      // "30+ cities",
      "Relevancy search",
      "Neighborhood Recommendations",
    ],
  },
];

const SubscriptionPlans = ({ userDetails, withBg=true, withHeader=false }) => {
  const { navigate } = useContext(StoreContext);

  const isInPricing = window.location.pathname === '/pricing';

  const handleCheckout = async (plan) => {
    // const userData = getLSData('user-data');
    // const response = await createCheckoutSession(
    //   userData?.email,
    //   plan.name,
    //   10
    // );
    // console.log('Checkout response:', response);
    navigate('/contact-us');
  };

  return (
    <div className={`flex flex-col justify-center py-8 w-full subscription-container ${
        withBg ? 'bg' : ''
      } ${
        withHeader ? 'pt-0' : ''
      }`}
    >
      <Show.When isTrue={withHeader}>
        <div className="bg-[#1c293a] text-white text-3xl text-center py-12 mb-8">
          <div className="px-4">Pricing</div>
        </div>
        <div className='text-center mb-8 text-[20px] px-6'>
          Uniquely tailored to meet your business goals
        </div>
      </Show.When>
      <div className='flex justify-center md:justify-between flex-wrap w-full max-w-[1200px] mx-auto'>
        {subscriptionPlans.map((plan, index) => {
          const isCurrentPlan = userDetails?.subscription?.tier === plan.tier;
          return (
            <div
              key={index}
              className='bg-[#1c293a] py-4 px-6 m-2 w-full max-w-[350px] flex flex-col gap-2 text-white text-left'
            >
              <h2 className='text-[#dcdcdc] text-xl font-medium'>{plan.name}</h2>
              <span className='text-lg'>
                <Show>
                  <Show.When isTrue={plan.tier === 'enterprise'}>
                    <div onClick={() => navigate('/contact-us')} className='cursor-pointer'>
                      Contact Us
                    </div>
                  </Show.When>
                  <Show.Else>
                    {`$${plan.price}`}
                    <Show.When isTrue={plan.per_month}>
                      <span className='text-sm !text-[#8b8b8b]'> /month</span>
                    </Show.When>
                  </Show.Else>
                </Show>
              </span>
              <ul className='features-list mb-4'>
                {plan.features.map((feature, index) => (
                  <li key={index}>
                    • {feature}
                  </li>
                ))}
              </ul>
              <Show>
              <Show.When isTrue={isCurrentPlan && !isInPricing}>
                <button
                  className={`mt-auto bg-gray text-black p-2 text-center ${
                    isCurrentPlan
                      ? 'bg-[#8b8b8b] text-[#6d6d6d] cursor-not-allowed'
                      : 'cursor-pointer'
                  }`}
                >
                  <span className='text-gray'>Current Plan</span>
                </button>
              </Show.When>
              <Show.Else>
                <button
                  className={`mt-auto p-2 text-center ${
                    plan.tier === 'free' && !isInPricing
                      ? 'bg-[#8b8b8b] text-[#6d6d6d] cursor-not-allowed'
                      : 'bg-white text-black cursor-pointer'
                  }`}
                  onClick={() => plan.tier === 'free' && isInPricing ? navigate('/signup') : handleCheckout(plan)}
                  disabled={plan.tier === 'free' && !isInPricing}
                >
                    <span className='text-gray'>
                      {plan.tier === 'free' && !isInPricing 
                        ? 'Free Plan'
                        : 'Get Started'
                      }
                    </span>
                  </button>
              </Show.Else>
            </Show>
            </div>
          );
        })}
      </div>
      <div className='text-center text-[#1c293a] text-lg my-8'>
        <div>For more questions, you may reach us at</div>
        <div className='font-medium'>info@walkspan.com</div>
      </div>
    </div>
  );
};

export default SubscriptionPlans;